/**
 * Created by idea on 27/03/2017.
 */
import {Component, Input} from '@angular/core';
import {UtilityService} from '../services/Utility.service';

@Component({
    selector: 'ick-price',
    template: `{{price + (currency ? currency : '')}}`
})
export class PriceComponent{
    private _price;

    @Input()
    set price(value : number){
        this._price = UtilityService.numberFormat(value,0,'.',',');
    }
    get price(){
        return this._price;
    }
    //size : small,medium,thumb_medium,thumb_medium,thumb_small,original
    @Input()
        currency: string;
    constructor(){
    }
}


// WEBPACK FOOTER //
// /app/src/app/common/helper/price.component.ts